import * as constants from './config/constants.js';
import Selectors from './utils/selectors.js';
import ElementClassHandler from './utils/element-class-handler';

const selectors = new Selectors();
const elementClassHandler = new ElementClassHandler;
const checkoutDetailsForm = document.getElementById('form_dateOfBirth_dateOfBirth_row');

export default class FormValidator {
 
    constructor(options = {}) {
        this.matchFields = options.matchFields || '';
        this.errorsSelector = 'data-error-id';
        this.fieldContainer = options.fieldContainer || '.form-group:not([data-no-validate])';
        this.fieldClass = options.fieldClass || '.' + constants.FIELD_CLASS;
        this.formGroupId = options.formGroupId || '[data-form-group-items]';
        this.invalidAfterSubmit = options.invalidAfterSubmit || '[data-invalid-after-submit]';
        this.formValidateOnSubmit = options.formValidateOnSubmit || '[data-validate-form-submit]';
        this.validClass = options.validClass || constants.VALID_CLASS;
        this.invalidClass = options.invalidClass || constants.INVALID_CLASS;
        this.lastFieldUntouched = options.lastFieldUntouched || 'data-last-field-untouched';
        this.formElement = document.querySelector(this.formValidateOnSubmit);
    }

    setup() {
        this.setupFieldValidation();
        this.forceNumberOnlyFields();
        this.setupMatchFields();
        this.setupRemoveErrorEventListeners();
        if (this.formElement) {
            this.registerFormValidationMethod();
            this.validateOnSubmit();
        }
        this.setupOnClick();
        this.setupLiveRegion();
    }

    setupLiveRegion() {
        if (document.getElementById('form-validation-announcer')) {
            this.liveRegion = document.getElementById('form-validation-announcer');
            return;
        }
        this.liveRegion = document.createElement('div');
        this.liveRegion.setAttribute('id', 'form-validation-announcer');
        this.liveRegion.setAttribute('aria-live', 'polite');
        this.liveRegion.setAttribute('aria-atomic', 'true');
        this.liveRegion.className = 'sr-only';
        document.body.appendChild(this.liveRegion);
    }

    setupOnClick() {
        const button = document.querySelector('.dob-check');
        if (button) {
            button.addEventListener('change', this.onclickYear.bind(this));
        }
    }

    onclickYear(event) {
        event.preventDefault();
        if (checkoutDetailsForm) {
            this.checkDateOfBirth();
        }
    }

    validateOnSubmit() {
        const formElem = this.formElement;
        const buttonElem = formElem.querySelector('button[type="submit"]');
        if (buttonElem) {
            buttonElem.addEventListener('click', (e) => {
                e.preventDefault();
                if (checkoutDetailsForm) {
                    let age = this.newCheckDateOfBirth();
                    if (age < 18) {
                        const elementDob = document.getElementById('form_dateOfBirth_row');
                        elementDob.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        return;
                    }
                }
                if (formElem.validateForm()) {
                    if (formElem.hasAttribute('data-recaptcha-target') && grecaptcha.getResponse().length == 0) {
                        /* global grecaptcha */
                        grecaptcha.execute();
                    } else {
                        formElem.submit();
                    }
                }
            });
        }
    }

    registerFormValidationMethod() {
        this.formElement.validateForm = () => {
            const formElem = this.formElement;
            let fields = formElem.querySelectorAll(this.fieldContainer + ' input', this.fieldContainer + ' select');
            let confirmError = document.getElementById('confirm-btn-error');
            let isClicked = document.getElementById('isClicked');

            //Adding below code to not distrub any other brand's flow
            if (document.querySelector('.checkout-network-switching[data-network-switching]')) {
                fields = formElem.querySelectorAll(this.fieldContainer + ' input,' + this.fieldContainer + ' select:not([data-validate="false"])');
                    let isConfirm = isClicked.getAttribute('data-clicked');
                    let input = document.querySelector('[data-network-switching-mobiles-toggle]');
                    if (input && input.checked == true) {
                            if (isConfirm == 'false' ) {
                                confirmError.style.display = 'block';
                                return;
                            }
                        }
            }
            const fieldsUntouched = formElem.querySelectorAll('[' + this.lastFieldUntouched + ']');
            if (fieldsUntouched) {
                fieldsUntouched.forEach((fieldUntouched) => {
                    fieldUntouched.removeAttribute(this.lastFieldUntouched);
                });
            }

            return !fields.length || this.validateFields(fields);
        };
    }
 
    matchField(entryField, matchField) {
        if (entryField.value) {
            matchField.setAttribute('pattern', entryField.value);
        }
        entryField.addEventListener('change', () => {
            matchField.setAttribute('pattern', entryField.value);
            this.validateField(matchField);
        });
    }
     
    validateField(elem) {
        if (elem[0] && elem.nodeName !== 'SELECT') {
            elem = elem[0];
        }
        const fieldset = document.querySelector('fieldset[data-form-group-items]');
        if (elem.validity) {
            const elemContainer = elem.parentElement;
            if (elem.validity.valid) {
                if (elemContainer.matches(this.formGroupId)) {
                    elementClassHandler.add(elem, this.validClass);
                    elementClassHandler.remove(elem, this.invalidClass);
                    const fields = elemContainer.querySelectorAll(elem.nodeName);
                    let validFields = true;
                    fields.forEach((input, index) => {
                        if (!input.validity.valid) {
                            elementClassHandler.remove(input, this.validClass);
                            elementClassHandler.add(input, this.invalidClass);
                            validFields = false;
                            if (elemContainer.matches('[' + this.lastFieldUntouched + ']')) {
                                return false;
                            }
                            const elemFieldContainer = elem.closest(this.fieldContainer);
                            elementClassHandler.remove(elemFieldContainer, this.validClass);
                            elementClassHandler.add(elemFieldContainer, this.invalidClass);
                            return false;
                        }
                        elementClassHandler.remove(input, this.invalidClass);
                        elementClassHandler.add(input, this.validClass);
                        if (elemContainer.matches('[' + this.lastFieldUntouched + ']')) {
                            return false;
                        }
                        if (index + 1 === fields.length && validFields) {
                            elementClassHandler.add(elemContainer, this.validClass);
                            elementClassHandler.remove(elemContainer, this.invalidClass);
                        }
                        const elemContainerParent = elemContainer.parentElement,
                            invalidAfterSubmit = elemContainerParent.querySelector(this.invalidAfterSubmit);
                        if (invalidAfterSubmit) {
                            invalidAfterSubmit.remove();
                        }
                    });
                } else {
                    const invalidAfterSubmitSection = elemContainer.querySelector(this.invalidAfterSubmit),
                        elemFieldContainer = elem.closest(this.fieldContainer);
                    if (invalidAfterSubmitSection) {
                        invalidAfterSubmitSection.remove();
                    }
                    elementClassHandler.add(elemFieldContainer, this.validClass);
                    elementClassHandler.remove(elemFieldContainer, this.invalidClass);
                    elementClassHandler.remove(elem, this.invalidClass);
                }
                elem.removeAttribute('aria-invalid');
                elem.removeAttribute('aria-describedby');
                    if (checkoutDetailsForm) {
                        this.checkDateOfBirth();
                    }
            } else {
                if (elemContainer.matches(this.formGroupId)) {
                    elementClassHandler.add(elem, this.invalidClass);
                    elementClassHandler.remove(elem, this.validClass);
                    if (elemContainer.matches('[' + this.lastFieldUntouched + ']')) {
                        return;
                    }
                }
                const elemFieldContainer = elem.closest(this.fieldContainer);
                elementClassHandler.remove(elemFieldContainer, this.validClass);
                elementClassHandler.add(elemFieldContainer, this.invalidClass);
                let helpBlock = elemFieldContainer ? elemFieldContainer.querySelector('.help-block') : null;
                if (!helpBlock && elemFieldContainer) {
                    // Fallback for fields like DOB where the help-block is a sibling,
                    // or inside a sibling container (e.g. form-errors-container)
                    const sibling = elemFieldContainer.nextElementSibling;
                    if (sibling) {
                        helpBlock = sibling.classList.contains('help-block')
                            ? sibling
                            : sibling.querySelector('.help-block');
                    }
                }
                elem.setAttribute('aria-invalid', 'true');
                // aria-describedby is intentionally not set here.
                if (fieldset) {
                    fieldset.style.borderColor = '#d13e39';
                    document.getElementById('dob-block').style.display = 'none';    
                }
            }
        }
    }

    removeValidationClasses(elem) {
        const elemFieldContainer = elem.closest(this.fieldContainer);
        elementClassHandler.remove(elemFieldContainer, this.invalidClass);
        elementClassHandler.remove(elemFieldContainer, this.validClass);
    }
 
    setupMatchFields() {
        if (this.matchFields) {
            for (let key in this.matchFields) {
                let entryField = document.querySelector(this.matchFields[key]),
                    matchField = document.querySelector(key);
                if (entryField && matchField) {
                    this.matchField(entryField, matchField);
                }
            }
        }
    }

    setupRemoveErrorEventListeners() {
        const errorFields = selectors.querySelectorArray(selectors.attrSelector(this.errorsSelector));
        if (errorFields.length) {
            errorFields.forEach((el) => {
                const formElemRow = document.querySelector('#' + el.getAttribute(this.errorsSelector) + '_row');
                if (formElemRow) {
                    const formFields = selectors.querySelectorArray('[name]', formElemRow);
                    if (formFields.length) {
                        formFields.forEach((elem) => {
                            let removeError = function() {
                                el.parentNode.removeChild(el);
                                elem.removeEventListener('focus', removeError, false);
                            };
                            elem.addEventListener('focus', removeError, false);
                        });
                    }
                }
            });
        }
    }
 
    setupFieldValidation() {
        const fieldContainers = document.querySelectorAll(this.fieldContainer);
        if (fieldContainers) {
            fieldContainers.forEach((fieldContainer) => {
                const fields = fieldContainer.querySelectorAll(this.fieldClass),
                    selectFields = fieldContainer.querySelectorAll('select'),
                    checkboxFields = fieldContainer.querySelectorAll('input[type="checkbox"]'),
                    radioFields = fieldContainer.querySelectorAll('[data-radio-selection] input[type="radio"]');
                if (fields) {
                    fields.forEach((field, index) => {
                        const fieldType = field.getAttribute('type'),
                            fieldParent = field.parentElement;
                        if (fieldType && fieldType === 'radio') {
                            return;
                        }
                        field.addEventListener('blur', (e) => {
                            e.preventDefault();
                            this.validateField(field);
                            if (fieldParent && fieldParent.matches(this.formGroupId)) {
                                const fieldContainer = field.closest(this.fieldContainer);
                                if (fieldContainer) {
                                    elementClassHandler.remove(fieldParent, 'focused');
                                }
                            }
                        });
                        field.addEventListener('focus', (e) => {
                            e.preventDefault();
                            clearTimeout(this.announceTimeout);
                            if (this.liveRegion) { this.liveRegion.textContent = ''; }
                            // If the field is invalid, announce its own error via live region.
                            // This avoids aria-describedby cross-field issues on Windows Narrator.
                            if (field.getAttribute('aria-invalid') === 'true') {
                                const fieldCont = field.closest(this.fieldContainer);
                                if (fieldCont) {
                                    let errorBlock = fieldCont.querySelector('.help-block');
                                    if (!errorBlock) {
                                        const sib = fieldCont.nextElementSibling;
                                        if (sib) {
                                            errorBlock = sib.classList.contains('help-block')
                                                ? sib
                                                : sib.querySelector('.help-block');
                                        }
                                    }
                                    const errorText = errorBlock ? errorBlock.textContent.trim() : '';
                                    if (errorText) {
                                        // Append the field's placeholder/label so that fields sharing
                                        // the same error message (e.g. DOB: DD, MM, YYYY all say
                                        // "Please enter a valid date") produce unique strings.
                                        // VoiceOver on Mac suppresses re-announcements of identical text.
                                        const fieldHint = field.getAttribute('placeholder') ||
                                            field.getAttribute('aria-label') ||
                                            (field.labels && field.labels[0] ? field.labels[0].textContent.trim() : '');
                                        const announcement = fieldHint ? `${errorText}, ${fieldHint}` : errorText;
                                        this.announceTimeout = setTimeout(() => {
                                            if (this.liveRegion && document.activeElement === field) {
                                                this.liveRegion.textContent = announcement;
                                            }
                                        }, 100);
                                    }
                                }
                            }
                            if (fieldParent && fieldParent.matches(this.formGroupId)) {
                                const fieldContainer = field.closest(this.fieldContainer);
                                if (fieldContainer) {
                                    elementClassHandler.add(fieldParent, 'focused');
                                    if (index + 1 === fields.length && fieldContainer.matches('[' + this.lastFieldUntouched + ']')) {
                                        fieldContainer.removeAttribute(this.lastFieldUntouched);
                                    }
                                }
                            }
                        });
                    });
                }
                if (selectFields) {
                    selectFields.forEach((field) => {
                        field.addEventListener('change', () => {
                            this.validateField(field);
                        });
                    });
                }
                if (selectFields) {
                    selectFields.forEach((field) => {
                        field.addEventListener('focus', () => {
                            this.validateField(field);
                        });
                    });
                }
                if (checkboxFields) {
                    checkboxFields.forEach((field) => {
                        field.addEventListener('change', () => {
                            this.validateField(field);
                        });
                    });
                }
                if (radioFields) {
                    radioFields.forEach((field) => {
                        field.addEventListener('change', () => {
                            const fieldContanier = field.closest(this.fieldContainer);
                            if (fieldContainer) {
                                elementClassHandler.remove(fieldContanier, this.invalidClass);
                            }
                        });
                    });
                }
            });
        }
    }

    validateFields(fields, showErrors = true, scrollToFirstError = true) {
        let isValidSubmission = true,
            firstError;
        if (fields.length) {
            fields.forEach((field) => {
                if (showErrors) {
                    this.validateField(field);
                }
                if (!field.validity.valid) {
                    if (scrollToFirstError && !firstError) {
                        firstError = field;
                    }
                    isValidSubmission = false;
                }
            });
        }
        if (isValidSubmission) {
            return true;
        }
        if (scrollToFirstError) {
            const labelHeight = 40,
                firstErrorPosition = (firstError.getBoundingClientRect().top + document.documentElement.scrollTop) - labelHeight;
            window.scrollTo(0, firstErrorPosition);
        }
    }

    forceNumberOnlyFields() {
        const numberFields = selectors.querySelectorArray('[type="number"], input[data-input-number]');
        if (numberFields.length) {
            numberFields.forEach((el) => {
                if (!el.getAttribute('data-force-number')) {
                    el.addEventListener('keypress', (e) => {
                        if (!e.key.match(/[0-9]|Backspace|Delete|Tab|Enter|ArrowLeft|ArrowRight|End|Home|PageDown|PageUp|Clear|Insert/)) {
                            e.preventDefault();
                        }
                    });
                    el.setAttribute('data-force-number', 'true');
                }
            });
        }
    }
    checkDateOfBirth() {
        const numberFields = selectors.querySelectorArray('[type="number"], input[data-input-number]');
        const host = window.location.hostname;
        let fieldset = document.querySelector('fieldset[data-form-group-items]');
        if (host.startsWith('www.carphonewarehouse')) {
            fieldset = document.querySelector('div[data-form-group-items]');
        }
        if (numberFields.length) {
            numberFields.forEach((el) => {
           if(el.classList.contains("is-invalid"))
           {
            fieldset.style.borderColor = '#d13e39';
           }
           else {
            fieldset.style.borderColor = '#808080';

           }
            });
               let date = document.getElementById('form_dateOfBirth_dateOfBirth_day').value;
               let month = document.getElementById('form_dateOfBirth_dateOfBirth_month').value;
               let year = document.getElementById('form_dateOfBirth_dateOfBirth_year').value;
               let dob = new Date(year, month - 1, date);

               let currentDate = new Date();
               let age = currentDate.getFullYear() - dob.getFullYear();
               let monthDiff = currentDate.getMonth() - dob.getMonth();
               let dayDiff = currentDate.getDate() - dob.getDate();
           
               if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
                   age--;
               }
               if(fieldset.classList.contains("is-invalid") && age < 18) {
                fieldset.style.borderColor = '#d13e39';
                document.getElementById('dob-block').style.display = 'block';
                } else if(fieldset.classList.contains("is-invalid") && (age == 18 || age >18))  {
                    fieldset.style.borderColor = '#d13e39';
                    document.getElementById('dob-block').style.display = 'none';
                } else if(fieldset.classList.contains("is-valid") && (age < 18))
                {
                    document.getElementById('dob-block').style.display = 'block';
                    fieldset.style.borderColor = '#d13e39';
                }
                else {
                    document.getElementById('dob-block').style.display = 'none';
                    fieldset.style.borderColor = '#808080';
                }
        }
    }
 
 
    newCheckDateOfBirth() {
        let date = document.getElementById('form_dateOfBirth_dateOfBirth_day').value;
        let month = document.getElementById('form_dateOfBirth_dateOfBirth_month').value;
        let year = document.getElementById('form_dateOfBirth_dateOfBirth_year').value;
        let dob = new Date(year, month - 1, date);
        let currentDate = new Date();
        let age = currentDate.getFullYear() - dob.getFullYear();
        let monthDiff = currentDate.getMonth() - dob.getMonth();
        let dayDiff = currentDate.getDate() - dob.getDate();
    
        if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
            age--;
        }
        
        const host = window.location.hostname;
        let fieldset = document.querySelector('fieldset[data-form-group-items]');
        if (host.startsWith('www.carphonewarehouse')) {
            fieldset = document.querySelector('div[data-form-group-items]');
        }
        let dobBlock = document.getElementById('dob-block');
    
        if (age < 18) {
            fieldset.style.borderColor = '#d13e39';
            dobBlock.style.display = 'block';
        } else {
            fieldset.style.borderColor = '#808080';
            dobBlock.style.display = 'none';
        }
    
        return age;
    } 
}
